import type {
  MeetTheCharacterDefaultContentTemplateDynamicZone,
  MeetTheCharactersPageQuery,
  MeetTheCharactersPageQueryVariables,
} from '@edwin-group/cj-graphql/generated/graphql';
import DefaultContentTemplatePage from '../default-content-template';

import { useQueryCacheAndNetwork } from '@/hooks/useQueryCacheAndNetwork';
import { QUERY_MEET_THE_CHARACTERS_PAGE } from '@edwin-group/cj-graphql';

const MeetTheCharactersPage = () => {
  const { data, loading } = useQueryCacheAndNetwork<MeetTheCharactersPageQuery, MeetTheCharactersPageQueryVariables>(
    QUERY_MEET_THE_CHARACTERS_PAGE,
  );

  if (loading) {
    return null;
  }
  const page = data?.meetTheCharacter;
  const template = page?.DefaultContentTemplate || null;

  return (
    <>
      <DefaultContentTemplatePage
        template={template as Array<MeetTheCharacterDefaultContentTemplateDynamicZone>}
        title={page?.pageTitle || 'Back to the Homepage'}
      />
    </>
  );
};

export default MeetTheCharactersPage;
